import React from 'react'
import { MdOutlineCancel } from 'react-icons/md'


import Grid from "@mui/material/Unstable_Grid2"
import {
    Box,
    Button,
    Typography,
    MenuItem,
    Select,
    Stack,
} from "@mui/material"
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator"

import ModalLayout from '../../../components/modals/Layout'
import { useGetUnits } from '../../../services/stores'
import { useSelector } from 'react-redux'
import CustomSnackBar from '../../../components/common/utils/CustomSnackBar'
import AxiosPrivate from '../../../functions/axios/axiosPrivate'
import ImageUploader from '../../../components/common/utils/ImageUploader'
import SideDrawer from '../../../components/common/SideDrawer'

const AddItem = ({
    visible,
    handleCancelButton,
    setOpen,


}) => {

    const { currentBranch } = useSelector((state) => state.branch);
    const branchId = currentBranch?.id;
    const { units: baseUnits, isLoading } = useGetUnits(branchId);
    console.log('units', baseUnits);
    const warehouses = []
    const [values, setValues] = React.useState({
        name: "",
        base_unit: "",
        warehouse: "",
        description: "",
        image: null,
        openSnackBar: false,
        snackBarMessage: "",
        snackBarSeverity: "success",
    })

    const {
        name,
        base_unit,
        warehouse,
        description,
        image,
        openSnackBar,
        snackBarMessage,
        snackBarSeverity,
    } = values

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value })
    }

    const changeImage = (url) => {
        setValues({ ...values, image: url })
    }

    const closeSnackBar = (_, reason) => {
        if (reason === "clickaway") return
        setValues({ ...values, openSnackBar: false })
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        if (!name || !base_unit || !warehouse || !image) return

        const payload = {
            name,
            branch: branchId,
            base_unit,
            warehouse,
            description,
            image,
        }

        AxiosPrivate.post("/inventory/items/", payload)
            .then(() => {
                setValues({
                    ...values,
                    snackBarMessage: "Item created successfully",
                    snackBarSeverity: "success",
                    openSnackBar: true,
                })

                setTimeout(() => {
                    handleCancelButton()
                }, 800)
            })
            .catch((err) => {
                setValues({
                    ...values,
                    snackBarMessage: err.message,
                    snackBarSeverity: "error",
                    openSnackBar: true,
                })
            })
    }

    return (
        <SideDrawer
            open={visible}
            onClose={handleCancelButton}
            title="Add Items"
        >
            <>
                {/* Snackbar */}
                <CustomSnackBar
                    openSnackBar={openSnackBar}
                    handleClose={closeSnackBar}
                    horizontal="center"
                    snackBarMessage={snackBarMessage}
                    snackBarSeverity={snackBarSeverity}
                />

                {/* Form */}
                <ValidatorForm onSubmit={handleSubmit} autoComplete="off">
                    <div className="border-t pt-5 space-y-2  gap-6">



                        {/* Image Upload */}
                        <Box>
                            <Typography>Item Image</Typography>
                            <Stack direction="row">
                                <ImageUploader
                                    changeAvatar={changeImage}
                                    title="Upload image"
                                />
                            </Stack>
                        </Box>
                        <Box></Box>
                        {/* Item Name */}
                        <Box>
                            <Typography>Item Name</Typography>
                            <TextValidator
                                fullWidth
                                value={name}
                                onChange={handleChange("name")}
                                validators={["required"]}
                                errorMessages={["Item name is required"]}
                            />
                        </Box>

                        {/* Base Unit */}
                        <Box>
                            <div className="flex items-center gap-5 pb-1 ">
                                <Typography>Base Unit</Typography> <button type='button' onClick={()=>setOpen(true)} className='rounded-sm bg-maroon-100 px-3 py-1 text-sm'> + Add </button>
                            </div>
                            <Select
                                fullWidth
                                value={base_unit}
                                onChange={handleChange("base_unit")}
                                displayEmpty
                            >
                                <MenuItem disabled value="">
                                    Select base unit
                                </MenuItem>
                                {baseUnits?.map((unit) => (
                                    <MenuItem key={unit.id} value={unit.id}>
                                        {unit.name} - ({unit.conversion_to_base})
                                    </MenuItem>
                                ))}
                            </Select>
                        </Box>

                        {/* Warehouse */}
                        <Box>
                            <Typography>Warehouse</Typography>
                            <Select
                                fullWidth
                                value={warehouse}
                                onChange={handleChange("warehouse")}
                                displayEmpty
                            >
                                <MenuItem disabled value="">
                                    Select warehouse
                                </MenuItem>
                                {warehouses.map((wh) => (
                                    <MenuItem key={wh.id} value={wh.id}>
                                        {wh.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Box>

                        {/* Description */}
                        <Box className="col-span-2">
                            <Typography>Description</Typography>
                            <TextValidator
                                fullWidth
                                multiline
                                minRows={3}
                                value={description}
                                onChange={handleChange("description")}
                            />
                        </Box>

                        {/* Submit */}
                        <Box className="col-span-2">
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                sx={{ mt: 3, color: "white" }}
                            >
                                Create Item
                            </Button>
                        </Box>

                    </div>
                </ValidatorForm>
            </>
            </SideDrawer>

    )
}

export default AddItem
